import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from "@mui/material";
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

const ACCENT_BLUE = '#22638f';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const cancelBtnSx = {
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '13px',
  color: TEXT_MUTED,
  border: `1px solid ${BORDER}`,
  borderRadius: '8px',
  padding: '8px 20px',
  '&:hover': {
    backgroundColor: '#f8fbfe',
    borderColor: TEXT_MUTED,
  },
};

const saveBtnSx = {
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '13px',
  color: '#fff',
  backgroundColor: ACCENT_BLUE,
  borderRadius: '8px',
  padding: '8px 24px',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: '#1a4d70',
    boxShadow: 'none',
  },
};

const textFieldSx = {
  '& .MuiInput-underline:before': { borderBottomColor: BORDER },
  '& .MuiInput-underline:hover:before': { borderBottomColor: ACCENT_BLUE },
  '& .MuiInput-underline:after': { borderBottomColor: ACCENT_BLUE },
  '& .MuiInputLabel-root': {
    color: TEXT_MUTED,
    fontSize: 13,
    fontWeight: 600,
  },
  '& .MuiInputLabel-root.Mui-focused': { color: ACCENT_BLUE },
  '& .MuiInputBase-input': {
    color: TEXT_BODY,
    fontSize: 14,
  },
};

function MetadataEditForm({
    open,
    onClose,
    metadataKeys = [],
    metadataValues = {},
    onSave,
}) {
    const [formValues, setFormValues] = useState({});

    useEffect(() => {
        setFormValues(metadataValues || {});
    }, [metadataValues]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        onSave(formValues);
        onClose();
    };

    return (
        <Dialog
          open={open}
          onClose={onClose}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '14px',
              boxShadow: '0 8px 32px rgba(12, 61, 110, 0.14)',
            },
          }}
        >
            <DialogTitle
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: TEXT_BODY,
                borderBottom: `1px solid ${BORDER}`,
                padding: '18px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              Edit metadata
              <IconButton
                onClick={onClose}
                size="small"
                sx={{ color: TEXT_MUTED }}
                aria-label="Close"
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </DialogTitle>

            <DialogContent sx={{ paddingX: 3, paddingY: 3 }}>
                {metadataKeys.length === 0 ? (
                  <p style={{ fontSize: 13, color: TEXT_MUTED, margin: 0 }}>
                    No metadata fields available.
                  </p>
                ) : (
                  metadataKeys.map((key) => (
                      <TextField
                          key={key}
                          label={key}
                          name={key}
                          margin="dense"
                          fullWidth
                          variant="standard"
                          value={formValues[key] || ""}
                          onChange={handleChange}
                          sx={textFieldSx}
                      />
                  ))
                )}
            </DialogContent>

            <DialogActions sx={{ padding: '16px 24px', borderTop: `1px solid ${BORDER}`, gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={cancelBtnSx}
                >
                  Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={saveBtnSx}
                >
                  Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MetadataEditForm;